import { render, staticRenderFns } from "./DistrictOutlineSelectbox.vue?vue&type=template&id=2135e55b&"
import script from "./DistrictOutlineSelectbox.vue?vue&type=script&lang=js&"
export * from "./DistrictOutlineSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports